import { toast } from "react-toastify";

export const shareContent = async ({ title, url }) => {
  if (!url) {
    toast.error("Không có link để chia sẻ");
    return;
  }

  try {
    if (navigator.share) {
      await navigator.share({ title, url });
    } else if (navigator.clipboard) {
      await navigator.clipboard.writeText(url);
      toast.success("Đã sao chép link chia sẻ");
    } else {
      toast.info("Trình duyệt của bạn không hỗ trợ chia sẻ");
    }
  } catch (error) {
    if (error?.name !== "AbortError") {
      toast.error("Không thể chia sẻ tài liệu");
    }
  }
};
